import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_bell_full",
  "use": "icon-i_bell_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_bell_full\"><title>icon_画板</title><path d=\"M29.71,25.93c-.28-1.8-3.46-2.18-3.51-3.42s.26-7.68.26-7.68c.18-5.06-3.29-7.83-6.86-9.1a.18.18,0,0,0,0-.06.17.17,0,0,0,0-.07,2.59,2.59,0,0,0-5.18,0v.08s0,0,0,.06c-3.57,1.27-7,4-6.87,9.1,0,0,.33,6.45.27,7.68s-3.23,1.62-3.51,3.42c-.18.7.62,1.4,1.39,1.4h8.16c0,.14,0,.28,0,.43a3.19,3.19,0,1,0,6.37,0,3,3,0,0,0,0-.43h8.15c.77,0,1.57-.7,1.4-1.4Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol